import {Component, Input, OnInit} from '@angular/core';
import {NotificationChannel} from '../../enum/notifications/notification-channel';
import {NotificationPreferencesService} from '../../services/push-notifications/notification-preferences.service';
import {NotificationPreferences} from '../../model/notification-preferences';
import {Store} from '@ngrx/store';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {selectUser} from '../../store/user/selectors/user.selectors';
import {map, Observable, take} from 'rxjs';
import {User} from '../../model/user';
import {selectUserRoles} from '../../store/auth/selectors/auth.selectors';

@Component({
    selector: 'app-notification-preferences',
    templateUrl: './notification-preferences.component.html',
    styleUrls: ['../../../styles/component-custom-style.scss', '../../../styles/form-input.scss'],
    standalone: false
})
export class NotificationPreferencesComponent implements OnInit {

  @Input() notificationType: string;
  @Input() onUpdate!: () => void;

  protected readonly NotificationChannel = NotificationChannel;
  protected readonly Object = Object;

  notificationPreferences$: Observable<NotificationPreferences[]>;
  activeUser: User = null;
  roles$ = this.userStore.select(selectUserRoles);

  constructor(private readonly notificationPreferencesService: NotificationPreferencesService,
              public userStore: Store<UserAppState>) {
  }

  ngOnInit(): void {
    this.userStore.select(selectUser).pipe(take(1)).subscribe(user => {
      this.activeUser = user;
      this.notificationPreferences$ = this.notificationPreferencesService.findAllByUserId(user.id).pipe(
        map(notificationPreferences =>
          notificationPreferences.filter(notificationPreference =>
            this.notificationPreferencesService.isNotificationTriggerBelongingToNotificationType(this.notificationType, notificationPreference.notificationTrigger)
            && this.notificationPreferencesService.isUserAllowedToViewNotificationTrigger(notificationPreference.notificationTrigger, user.type, user.isRepresentative)
          ))
      );
    });

  }

  onPreferencesChanged(updatedPreference: NotificationPreferences): void {
    updatedPreference.allDisabled = false;
    this.notificationPreferencesService.updateById(updatedPreference.id, updatedPreference).subscribe(() => this.onUpdate());
  }

}
